import React from "react";
import spinner from "../assets/spinner.gif"; // Adjust the path based on your folder structure

const Spinner = ({ heightResponsive = false, hidden = false }) => {
  return (
    <img
      src={spinner}
      alt="Loading..."
      className={heightResponsive ? "h-full w-auto" : "w-full h-auto"}
      style={{ display: hidden ? "none" : "initial" }}
    />
  );
};

export default Spinner;
